import React from 'react';
import PropTypes from 'prop-types';
import { SLIDE_UP } from 'react-ladda';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import { MainHeader } from '../../components/Header';
// import { injectReducer, injectSaga } from 'redux-injectors';
import injectReducer from '../../utils/injectReducer';
import injectSaga from '../../utils/injectSaga';
import { Collections, SearchFilterCollection } from '../../components/ViewCollections';
import { ButtonCustom, TablePagination, AccountHeaderForm } from '../../components/common';
import { getAccountId } from '../../localStorage';
import { checkPermissionViewTransactions } from '../../utils/CheckPermissions';
import { makeGetPermissionSelfCare } from '../App/selectors';
import { makeGetCollectionUnit, makePageTransactionParams } from './selectors';
import reducer from './reducer';
import saga from './saga';
import './styles.scss';
import { FormHeader } from '../../components/form';
import { getCollectionUnit, getCollectionUnitById } from './actions';
import { getPageTotalCount } from '../../utils/utils';

export class ViewCollectionsPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.filter = { accountId: getAccountId() };
    this.state = {
      isActiveNext: true,
      isSearching: false,
      page: 0,
      size: 20,
      filter: {},
      sorted: {},
      totalCount: null,
    };
    this.sort = '';
  }

  componentDidMount() {
    this.doGetCollectionUnit();
  }

  doGetCollectionUnit = () => {
    const { page, size, filter, totalCount } = this.state;
    const { getCollectionUnit } = this.props;

    this.setState({ isSearching: true });
    const params = {
      page: page + 1,
      size,
      filter: { ...filter, accountId: getAccountId() },
    };

    getCollectionUnit(params, ({ success, data }) => {
      this.setState({
        isSearching: false,
        page,
        size,
        filter,
        data: success ? data : [],
        isActiveNext: !!(data && data.length === size),
        totalCount: getPageTotalCount({ totalCount: totalCount || data?.length, size, items: data || [], page }),
      });
    });
  };

  onHandleSearch = filteredData => {
    this.setState({ filter: { ...filteredData }, page: 0 }, () => this.doGetCollectionUnit());
  };

  onPageChange = pageChange => {
    const { page } = this.state;
    if (page === pageChange) return '';
    return this.setState({ page: pageChange }, () => this.doGetCollectionUnit());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetCollectionUnit());
  };

  renderContent() {
    const { transactionUnit, getCollectionUnitById, t } = this.props;

    const { totalCount, page, size } = this.state;

    return (
      <div className="transactions">
        <div className="transactions-form">
          <br />
          <Row>
            <Col md={12}>
              {/* <h4 className="card-title-mb">
                {t('label.collectionActivity')}
                <span className="account-number">
                  <span className="account-detail">{`${t('label.accountNumber')}:`}</span>
                  &nbsp;&nbsp;
                  <span className="account-detail">{getAccountId()}</span>
                </span>
              </h4> */}
              <AccountHeaderForm title={t('label.collectionActivity')} />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={12}>
              <SearchFilterCollection onSubmit={this.onHandleSearch} isSearching={this.state.isSearching} />
            </Col>
          </Row>
          <br />
          <Collections data={transactionUnit} getCollectionUnitById={getCollectionUnitById} />
          <br />
          <ButtonCustom
            className="btn-cancel float-right mr-4"
            type="button"
            title={t('label.cancel')}
            datastyle={SLIDE_UP}
            onClick={() => {
              this.props.history.push('/');
            }}
          />
          <br />
          <br />
          <br />
          <div className="mb-30">
            <TablePagination
              pageNumber={page}
              pageSize={size}
              totalCount={totalCount}
              onPageChange={this.onPageChange}
              onSizeChange={this.onSizeChange}
            />
          </div>
        </div>
        <br />
        <br />
      </div>
    );
  }

  render() {
    const { permissionsSelfCare } = this.props;
    // let modeViewTransactions = 0;
    // if (permissionsSelfCare && permissionsSelfCare.selfCareModulePermissions) {
    //   const listPermission = permissionsSelfCare.selfCareModulePermissions;
    //   modeViewTransactions = checkPermissionViewTransactions({
    //     listPermission,
    //   });
    // }
    return (
      <div className="view-transactions-page">
        <MainHeader activeTab="Reports" />
        <div className="view-transactions-page__form">
          <div className="form-wrapper table-content">{this.renderContent()}</div>
        </div>
      </div>
    );
  }
}

ViewCollectionsPage.propTypes = {
  history: PropTypes.object,
  transactionUnit: PropTypes.array,
  params: PropTypes.object,
  getCollectionUnit: PropTypes.func,
  permissionsSelfCare: PropTypes.object,
};

const mapStateToProps = createStructuredSelector({
  transactionUnit: makeGetCollectionUnit() || [],
  params: makePageTransactionParams() || {},
  permissionsSelfCare: makeGetPermissionSelfCare() || {},
});

const withConnect = connect(mapStateToProps, {
  getCollectionUnit,
  getCollectionUnitById,
});

const withReducer = injectReducer({
  key: 'viewCollectionsPageReducer',
  reducer,
});
const withSaga = injectSaga({ key: 'viewCollectionsPageSaga', saga });

export default withTranslation('common')(compose(withReducer, withSaga, withConnect)(ViewCollectionsPage));
